<template>
  <b-form-group :label="label" class="mr-2">
    <date-range-picker
      ref="dateRangePicker"
      v-model="valuesObj"
      :showDropdowns="true"
      :autoApply="true"
      :linkedCalendars="false"
      @update="updateDateRangeValues"
      style="min-width: 230px;"
    >
      <template v-slot:input="{ startDate, endDate }">
        {{ startDate | date }} - {{ endDate | date }}
      </template>

      <template v-slot:ranges="{ startDate, endDate, ranges }">
        <div class="ranges col-12 col-md-auto">
          <ul>
            <li
              v-for="(value, name, index) in ranges"
              :key="index"
              @click="setDateRanges(value)"
            >
              {{ name }}
            </li>
            <li @click="setDateRangeAll">All</li>
          </ul>
        </div>
      </template>
    </date-range-picker>
  </b-form-group>
</template>

<script>
import moment from 'moment';

import { debounce } from 'lodash';
import { SEARCH_DEBOUNCE_TIME } from '@/shared/constants';

import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  components: {
    DateRangePicker,
  },
  props: {
    handleSearch: {
      type: Function,
      default: () => {},
    },
    label: {
      type: String,
      default: 'Date Range'
    }
  },
  data() {
    return {
      valuesObj: {
        startDate: '',
        endDate: '',
      },
      filters: {
        dateFrom: '',
        dateTo: '',
      },
    }
  },
  methods: {
    updateDateRangeValues(values) {
      this.valuesObj.startDate = moment(values.startDate).format('MM-DD-YYYY');
      this.valuesObj.endDate = moment(values.endDate).format('MM-DD-YYYY');
    },
    setDateRanges(value) {
      this.$refs.dateRangePicker.clickRange(value);
    },
    setDateRangeAll() {
      this.valuesObj.startDate = '';
      this.valuesObj.endDate = '';

      this.$refs.dateRangePicker.togglePicker(false, true);
    },
    onSearch: debounce(async function() {
      await this.handleSearch(this.filters);
    }, SEARCH_DEBOUNCE_TIME),
  },
  watch: {
    valuesObj: {
      async handler(newVal) {
        this.filters = {
          dateFrom: this.valuesObj.startDate,
          dateTo: this.valuesObj.endDate,
        };

        await this.onSearch();
      },
      deep: true
    }
  },
  filters: {
    date(value) {
      if (!value) return '';

      let options = {year: 'numeric', month: 'long', day: 'numeric'};
      
      return Intl.DateTimeFormat('en-US', options).format(value);
    },
  },
}
</script>

<style>
.daterangepicker {
  width: 637px !important;
}
</style>